import {
  asyncActionError,
  asyncActionFinish,
  asyncActionStart,
} from '../../asyncActions/asyncActions';
import {
  FETCH_ADMIN_AND_REVIEWER,
  FETCH_ALL_ADMINS_AND_REVIEWERS,
  FETCH_ALL_TEMPLATES,
  FETCH_SIGNNOW_SETTINGS,
  FETCH_TEMPLATE,
  FETCH_VIEW_CAROUSEL_SETTINGS,
  FETCH_NEWS_ANNOUNCEMENTS_DETAILS,
} from '../../../constants/adminConstants/settingsConstants/settingsConstants';

import axios from '../../../../config/axios';
import cuid from 'cuid';

export const fetchAllAdminsAndReviewers = () => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    const usersQuery = firestore
      .collection('users')
      .where('isApplicant', '==', false)
      .orderBy('fullName', 'asc');

    try {
      dispatch(asyncActionStart());
      let query = await usersQuery.get();

      let allAdminsAndReviewers = [];

      for (let i = 0; i < query.docs.length; i++) {
        let users = {
          ...query.docs[i].data(),
          id: query.docs[i].id,
        };
        allAdminsAndReviewers.push(users);
      }

      dispatch({
        type: FETCH_ALL_ADMINS_AND_REVIEWERS,
        payload: { allAdminsAndReviewers },
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
    }
  };
};

export const fetchAdminAndReviewer = (id) => {
  return async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    const userQuery = firestore.collection('users').doc(`${id}`);

    try {
      dispatch(asyncActionStart());

      let query = await userQuery.get();

      let adminAndReviewer = [];

      if (query.exists) {
        let user = {
          id: query.id,
          ...query.data(),
        };
        adminAndReviewer.push(user);
      }

      if (!query.exists) {
        dispatch(asyncActionFinish());
        return;
      }

      dispatch({
        type: FETCH_ADMIN_AND_REVIEWER,
        payload: { adminAndReviewer },
      });

      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
    }
  };
};

export const fetchAllTemplates = () => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    const templatesQuery = firestore.collection('templates');

    try {
      dispatch(asyncActionStart());
      let query = await templatesQuery.get();

      let allTemplates = [];

      for (let i = 0; i < query.docs.length; i++) {
        let template = {
          ...query.docs[i].data(),
          id: query.docs[i].id,
        };
        allTemplates.push(template);
      }

      dispatch({
        type: FETCH_ALL_TEMPLATES,
        payload: { allTemplates },
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
    }
  };
};

export const fetchTemplate = (id) => {
  return async (dispatch, getState, { getFirestore }) => {
    const firestore = getFirestore();

    const templatesQuery = firestore.collection('templates').doc(`${id}`);

    try {
      dispatch(asyncActionStart());

      let query = await templatesQuery.get();

      let template = [];

      if (query.exists) {
        let temp = {
          id: query.id,
          ...query.data(),
        };
        template.push(temp);
      }

      if (!query.exists) {
        dispatch(asyncActionFinish());
        return;
      }

      dispatch({
        type: FETCH_TEMPLATE,
        payload: { template },
      });

      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
    }
  };
};

export const addTemplate = (values, html) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    const templateQuery = firestore.collection('templates');

    try {
      dispatch(asyncActionStart());

      const query = await templateQuery.add({
        ...values,
        html: html,
        templateActive: true,
        createdAt: new Date().toISOString(),
      });

      dispatch(asyncActionFinish());

      return query;
    } catch (err) {
      dispatch(asyncActionError());
      console.log(err);
    }
  };
};

export const updateTemplate = (id, values, html) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    const templateQuery = firestore.collection('templates').doc(`${id}`);

    try {
      dispatch(asyncActionStart());

      const query = await templateQuery.update({
        ...values,
        html: html,
        templateActive: true,
        createdAt: new Date().toISOString(),
      });

      dispatch(asyncActionFinish());

      return query;
    } catch (err) {
      dispatch(asyncActionError());
      console.log(err);
    }
  };
};

export const disableTemplate = (id) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    const templateQuery = firestore.collection('templates').doc(`${id}`);

    try {
      dispatch(asyncActionStart());

      const query = await templateQuery.update({
        templateActive: false,
      });

      dispatch(fetchAllTemplates());
      dispatch(asyncActionFinish());

      return query;
    } catch (err) {
      dispatch(asyncActionError());
      console.log(err);
    }
  };
};

export const enableTemplate = (id, templateCategory) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    const templatesQuery = firestore
      .collection('templates')
      .where('templateCategory', '==', `${templateCategory}`);
    const templateQuery = firestore.collection('templates').doc(`${id}`);

    try {
      dispatch(asyncActionStart());

      let tempQuery = await templatesQuery.get();

      let allTemplates = [];

      for (let i = 0; i < tempQuery.docs.length; i++) {
        let template = {
          ...tempQuery.docs[i].data(),
          id: tempQuery.docs[i].id,
        };
        allTemplates.push(template);
      }

      if (allTemplates.length > 0) {
        for (let i = 0; i < allTemplates.length; i++) {
          const templateQuery = firestore
            .collection('templates')
            .doc(`${allTemplates[i].id}`);

          await templateQuery.update({
            templateActive: false,
          });
        }
      }

      const query = await templateQuery.update({
        templateActive: true,
      });

      dispatch(fetchAllTemplates());
      dispatch(asyncActionFinish());

      return query;
    } catch (err) {
      dispatch(asyncActionError());
      console.log(err);
    }
  };
};

export const deleteTemplate = (id) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    const templateQuery = firestore.collection('templates').doc(`${id}`);

    try {
      dispatch(asyncActionStart());

      await templateQuery.delete();

      dispatch(fetchAllTemplates());
      dispatch(asyncActionFinish());
    } catch (err) {
      dispatch(asyncActionError());
      console.log(err);
    }
  };
};

export const addSignNowSettings = (values) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    const signNowQuery = firestore.collection('signNowSettings');

    try {
      dispatch(asyncActionStart());

      const query = await signNowQuery.add({
        ...values,
        createdAt: new Date().toISOString(),
      });

      dispatch(asyncActionFinish());

      return query;
    } catch (err) {
      dispatch(asyncActionError());
      console.log(err);
    }
  };
};

export const updateSignNowSettings = (id, values) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    const signNowQuery = firestore.collection('signNowSettings').doc(`${id}`);

    try {
      dispatch(asyncActionStart());

      const query = await signNowQuery.update({
        ...values,
        createdAt: new Date().toISOString(),
      });

      dispatch(asyncActionFinish());

      return query;
    } catch (err) {
      dispatch(asyncActionError());
      console.log(err);
    }
  };
};

export const updateViewCarouselSettingsForBanner = (values) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    const settingsQuery = firestore.collection('settings').doc(`${values.id}`);

    try {
      dispatch(asyncActionStart());
      await settingsQuery.update({
        showCarouselForBanner: values.showCarouselForBanner,
      });

      dispatch(asyncActionFinish());
    } catch (err) {
      dispatch(asyncActionError());
      console.log(err);
    }
  };
};

export const updateNewsAndAnnouncements = (id, values, file) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();

    const settingsQuery = firestore.collection('settings').doc(`${id}`);

    try {
      dispatch(asyncActionStart());
      let fileExtension = '';

      if (file[0].type === 'image/jpeg') {
        fileExtension = '.jpeg';
      }

      if (file[0].type === 'image/jpg') {
        fileExtension = '.jpg';
      }

      if (file[0].type === 'image/png') {
        fileExtension = '.png';
      }

      if (file) {
        const fileName = cuid() + fileExtension;
        const path = `settings/${id}/newsOrAnnouncements`;
        const options = {
          name: fileName,
        };

        let uploadedFile = await firebase.uploadFile(
          path,
          file[0],
          null,
          options
        );

        // get download URL
        let downloadURL =
          await uploadedFile.uploadTaskSnapshot.ref.getDownloadURL();
        const query = await settingsQuery.get();
        // add image name and URL to firestore
        await settingsQuery.update({
          newsOrAnnouncements: query.data().newsOrAnnouncements
            ? [
                ...query.data().newsOrAnnouncements,
                {
                  id: cuid(),
                  heading: values.heading,
                  details: values.details,
                  imageUrl: downloadURL,
                },
              ]
            : [
                {
                  id: cuid(),
                  heading: values.heading,
                  details: values.details,
                  imageUrl: downloadURL,
                },
              ],
        });
      }

      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
    }
  };
};

export const fetchViewCarouselSettingsForBanner = () => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    const settingsQuery = firestore.collection('settings');

    try {
      dispatch(asyncActionStart());
      let query = await settingsQuery.get();

      let settings = [];

      for (let i = 0; i < query.docs.length; i++) {
        let setting = {
          ...query.docs[i].data(),
          id: query.docs[i].id,
        };
        settings.push(setting);
      }

      dispatch({
        type: FETCH_VIEW_CAROUSEL_SETTINGS,
        payload: { settings },
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
    }
  };
};

export const fetchNewsAndAnnouncementDetails = (id) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    const settingsQuery = firestore.collection('settings');

    try {
      dispatch(asyncActionStart());
      let query = await settingsQuery.get();

      let settings = [];
      let newsDetails = {};

      for (let i = 0; i < query.docs.length; i++) {
        let setting = {
          ...query.docs[i].data(),
          id: query.docs[i].id,
        };
        settings.push(setting);
      }

      if (
        settings &&
        settings?.length &&
        settings[0]?.newsOrAnnouncements?.length
      ) {
        newsDetails = settings[0].newsOrAnnouncements.find((x) => x.id === id);
      }

      dispatch({
        type: FETCH_NEWS_ANNOUNCEMENTS_DETAILS,
        payload: { newsDetails },
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
    }
  };
};

export const fetchSignNowSettings = () => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();

    const signNowQuery = firestore.collection('signNowSettings');

    try {
      dispatch(asyncActionStart());
      let query = await signNowQuery.get();

      let signNow = [];

      for (let i = 0; i < query.docs.length; i++) {
        let settings = {
          ...query.docs[i].data(),
          id: query.docs[i].id,
        };
        signNow.push(settings);
      }

      dispatch({
        type: FETCH_SIGNNOW_SETTINGS,
        payload: { signNow },
      });
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
    }
  };
};

export const createAdminAndReviewer = (values) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    let randomPassword = '';
    // let string = "ABCDEFGHIJKLMNOPQRSTUVWXYZ" + "abcdefghijklmnopqrstuvwxyz0123456789@#$";
    let string =
      'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789@#$';

    for (let i = 1; i <= 8; i++) {
      let char = Math.floor(Math.random() * string.length + 1);
      randomPassword += string.charAt(char);
    }

    const firstName = values.firstName;
    const lastName = values.lastName;
    const email = values.email;

    const accountType = values.accountType;
    const accountCapacity = values.accountCapacity;
    const profileImageURL =
      'data:image/png;base64,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';

    const password = randomPassword;

    try {
      dispatch(asyncActionStart());
      const createUserQuery = await axios.get('/adminUserFunctions/create', {
        params: {
          firstName,
          lastName,
          email,
          accountType,
          password,
          profileImageURL,
          accountCapacity,
        },
      });
      dispatch(fetchAllAdminsAndReviewers());
      dispatch(asyncActionFinish());
      return createUserQuery;
    } catch (err) {
      console.log(err);
    }
  };
};

export const deleteAdminAndReviewer = (id) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    try {
      dispatch(asyncActionStart());

      const deleteUserQuery = await axios.get('/adminUserFunctions/delete', {
        params: {
          id: id,
        },
      });

      dispatch(fetchAllAdminsAndReviewers());
      dispatch(asyncActionFinish());
      return deleteUserQuery;
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
    }
  };
};

export const disableAdminAndReviewer = (id) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    try {
      dispatch(asyncActionStart());

      const disableUserQuery = await axios.get(
        '/adminUserFunctions/disableUser',
        {
          params: {
            id: id,
          },
        }
      );

      dispatch(fetchAllAdminsAndReviewers());
      dispatch(asyncActionFinish());
      return disableUserQuery;
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
    }
  };
};

export const enableAdminAndReviewer = (id) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    try {
      dispatch(asyncActionStart());

      const enableUserQuery = await axios.get(
        '/adminUserFunctions/enableUser',
        {
          params: {
            id: id,
          },
        }
      );

      dispatch(fetchAllAdminsAndReviewers());
      dispatch(asyncActionFinish());
      return enableUserQuery;
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
    }
  };
};

export const updateAdminAndReviewerAuthEmail = (id, email) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    try {
      dispatch(asyncActionStart());

      const userAuthEmailQuery = axios.get(
        '/adminUserFunctions/updateAuthEmail',
        {
          params: {
            id: id,
            email: email,
          },
        }
      );

      dispatch(asyncActionFinish());
      return userAuthEmailQuery;
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
      return error;
    }
  };
};

export const updateAdminAndReviewer = (id, values) => {
  return async (dispatch, getState, { getFirebase, getFirestore }) => {
    const firestore = getFirestore();

    const updateUserQuery = firestore.collection('users').doc(`${id}`);

    try {
      dispatch(asyncActionStart());

      let isAdmin = false;
      let isReviewer = false;
      let isApplicant = false;
      let isAdminViewer = false;
      if (values.accountType === 'Admin') {
        isAdmin = true;
        isReviewer = false;
        isApplicant = false;
        isAdminViewer = false;
      }
      if (values.accountType === 'Reviewer') {
        isAdmin = false;
        isReviewer = true;
        isApplicant = false;
        isAdminViewer = false;
      }
      if (values.accountType === 'AdminViewer') {
        isAdmin = false;
        isReviewer = false;
        isApplicant = false;
        isAdminViewer = true;
      }

      await updateUserQuery.update({
        ...values,
        isAdmin: isAdmin,
        isReviewer: isReviewer,
        isApplicant: isApplicant,
        isAdminViewer: isAdminViewer,
        fullName: `${values.firstName + ' ' + values.lastName}`,
      });

      dispatch(fetchAdminAndReviewer(id));
      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
    }
  };
};

export const uploadImageForBanner = (id, files) => {
  return async (dispatch, getState, { getFirestore, getFirebase }) => {
    const firestore = getFirestore();
    const firebase = getFirebase();

    const settingsQuery = firestore.collection('settings').doc(`${id}`);

    try {
      dispatch(asyncActionStart());

      const images = [];

      for (let file of files) {
        const fileName = cuid() + '.' + file.name.split('.').pop();

        const path = `settings/${id}/imagesForBanner`;
        const options = {
          name: fileName,
        };

        let uploadedFile = await firebase.uploadFile(path, file, null, options);

        let downloadURL =
          await uploadedFile.uploadTaskSnapshot.ref.getDownloadURL();

        images.push(downloadURL);
      }

      const query = await settingsQuery.get();

      await settingsQuery.update({
        imagesForBanner: query.data()?.imagesForBanner
          ? [...query.data().imagesForBanner, ...images]
          : [...images],
      });

      dispatch(asyncActionFinish());
    } catch (error) {
      dispatch(asyncActionError());
      console.log(error);
    }
  };
};
